import React, { Component, PropTypes } from "react";
import { Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider } from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import css from './index.css';

import { hasAuth } from "../../../utils/NHCore";
import NHTable from "../../common/NHTable";

const baseUrlPath = "/tjcx/xsblxxhzcx"; //基础路径


/**
 * 学生办理信息汇总-四川交通职院
 * @author lijinbiao
 * @date 2021-8-21
 * Version: 1.0
 */
export default class XsblxxhzcxIndex extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
            highSearch:false,
        }
    }

    componentWillMount() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px'
            }, {
                title: '年度',
                dataIndex: 'ND',
                width: '70px'
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType: "input"
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType: "input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB'
            }, {
                title: '入学年份',
                width: '120px',
                dataIndex: 'RXNF',
                searchType: "select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px'
            }, {
                title: '校区',
                width: '200px',
                dataIndex: 'XQMC'
            }, {
                title: '院系',
                width: '200px',
                dataIndex: 'BMMC',
                searchType: "select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType: "select",
                parentField: "BMMC"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType: "select",
                parentField: "ZYMC"
            }, {
                title: '是否报道',
                dataIndex: 'SFBD',
                width: '120px'
            }, {
                title: '卧具费',
                width: '150px',
                dataIndex: 'WJF',
                searchType: "select"
            }, {
                title: '军训服装费',
                width: '150px',
                dataIndex: 'JXFZF',
                searchType: "select"
            }, {
                title: '住宿费',
                width: '90px',
                dataIndex: 'ZSF',
                searchType: "select"
            }, {
                title: '缴费时间',
                width: '200px',
                dataIndex: 'JFSJ',
                searchType: "date"
            }, {
                title: '楼栋',
                width: '90px',
                dataIndex: 'LDMC',
                searchType: "input"
            }, {
                title: '楼层',
                width: '90px',
                dataIndex: 'LCMC',
                searchType: "input"
            }, {
                title: '房间',
                width: '90px',
                dataIndex: 'FJMC',
                searchType: "input"
            }, {
                title: '床位',
                width: '90px',
                dataIndex: 'CWH'
            }, {
                title: '入住时间',
                width: '200px',
                dataIndex: 'RZSJ',
                searchType: "date"
            },
            {
                title: '物品购买时间',
                width: '200px',
                dataIndex: 'BLSJ',
                searchType: "date"
            },
        ];
        this.setState({
            columns: columnConst,
        }, () => {
            this.getColumn();
        });
    }

    //获取动态字段
    getColumn = () => {

        NHFetch(baseUrlPath + "/getZzbdList", "GET", new Date().getTime()).then(
            res => {
                if (res && res.code === 200 && res.data) {
                    let columnLet = this.state.columns;
                    res.data.map((item, key) => {
                        let column = {
                            title: item.HJMC,
                            width: '150px',
                            dataIndex: "A" + key,
                            searchType: "select"
                            // render: (text) => {
                            //     return text == '已办理' ?
                            //         <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                            //         : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>;
                            // }
                        };
                        columnLet.push(column);
                    });
                    this.setState({
                        columns: columnLet
                    });
                }
            }
        )


    }

    handleOtpBtnClick = () => {
        let exportParams = { gridUrl: `/tjcx/xsblxxhzcx/gridList/excel/params`, exportUrl: `/tjcx/xsblxxhzcx/gridList/excel/export1` };
        this.refs.nhTable.exportExcel('学生办理信息汇总', exportParams);
    }

    refreshHeight = () => {
        //如果需要自适应高度
        if (!this.props.autoHeightFlag && document.getElementsByClassName(this.state.className)) {
            let lastHeight = this.state.height;
            let height = getSuitHeight(document.getElementsByClassName(this.state.className)[0]);
            let titleHeight = (this.props.titleHeight || his.props.titleHeight === 0) ? this.props.titleHeight : 40;
            //如果不显示头部，则头部的高度为0
            if (this.props.showHeader !== true) { titleHeight = 0; }
            let reduceHeight = 40 + titleHeight;
            if (this.props.footerFlag === false) {
                reduceHeight = 5 + titleHeight;
            }
            height = height - reduceHeight;
            if (!lastHeight || lastHeight != height) {
                this.setState({
                    height: height
                });
            }
        }
    }

    render() {
        console.log('001:',getSize().windowH - 123);
        return (
            <div className={css.main_right_content} style={{ minHeight: getSize().windowH - 230 }}>
                <div className={css.table}>
                    <NHTable ref='nhTable'
                        rowKey={record => record.PKID}
                        columns={this.state.columns}
                        sign={"zhxg_yxxt_tjcx_xsblxxhz_queryPage"}
                        url={"/tjcx/xsblxxhzcx/gridList"}
                        rangeFilter={true}>
                        <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.handleOtpBtnClick}>导出</Button>
                    </NHTable>

                </div>
            </div>
        )
    }
    
}




// WEBPACK FOOTER //
// ./components/tjcx/xsblxxhzcx/index.js